module.exports = __webpack_public_path__ + "images/landing/video-previews/thanksgiving_offer_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/thanksgiving_offer_2x.jpg
// module id = DbF/
// module chunks = 1